<h2 class="content-block">Liste des bons</h2>
<div style="display: flex; align-items: baseline; justify-content: space-between;">
  <div>
    <div style="display: flex; align-items: center; margin: 0px 24px;">
      <span style="margin-right: 12px;">Lieu de stockage de référence :</span>
      <dx-select-box
        #lieuStockageSelectBox
        [items]="lieuStockages"
        [width]="270"
        [showClearButton]="true"
        displayExpr="intitule"
        valueExpr="id"
        [value]="this.selectedLieuStockage?.id"
        [searchEnabled]="true"
        [searchExpr]="['intitule', 'codeBo']"
        (onValueChanged)="onValueChanged($event)"
        style="margin-right: 12px;"
      ></dx-select-box>
      <dx-button text="Rafraîchir" (onClick)="refreshDataSource()"></dx-button>
    </div>
  </div>
  <div style="display: flex; align-items: center; margin: 0px 12px;">
    <div [title]="messageCannotCreerBon">
      <dx-drop-down-button
        text="Créer un bon"
        icon="add"
        [items]="mouvementTypeDataSource"
        displayExpr="intitule"
        keyExpr="id"
        style="margin-right: 12px;"
        [width]="220"
        (onItemClick)="onCreateNewBon($event)"
        [dropDownOptions]="dropDownOptionsCreerBon"
        [disabled]="!isCreerBonBtnEnabled"
      ></dx-drop-down-button>
      <dx-button icon="upload" (onClick)="showImportPopup = true;" [disabled]="!isCreerBonBtnEnabled"></dx-button>
    </div>
  </div>
</div>

<div class="row">
  <span class="field">
    <dx-button text="Ouvert" (onClick)="onStatutSelected(fluxStatutSimplifieEnum.ouvert)" [disabled]="currentFiltreStatut == fluxStatutSimplifieEnum.ouvert"></dx-button>
    <dx-button text="Fermé" (onClick)="onStatutSelected(fluxStatutSimplifieEnum.ferme)" [disabled]="currentFiltreStatut == fluxStatutSimplifieEnum.ferme"></dx-button>
    <dx-button text="Tous" (onClick)="onStatutSelected(fluxStatutSimplifieEnum.tous)" [disabled]="currentFiltreStatut == fluxStatutSimplifieEnum.tous"></dx-button>
  </span>

  <div class="field" style="display: flex; align-items: center;">
    <dx-switch
      [(value)]="includeInfosCalculees"
      [elementAttr]="{class: 'mr-12'}"
      (onValueChanged)="storeIncludeInfosCalculeesValue()"
    ></dx-switch>
    <span>Avec détails</span>
  </div>
</div>

<div style="margin-top: 12px;">
  <app-bon-list-globale-datagrid
    #bonListGlobaleDatagridComponent
    *ngIf="selectedLieuStockage == null"
    [fluxEtapeDataSource]="fluxEtapeDataSource"
    [currentPartenaireId]="currentPartenaireId"
    [includeInfosCalculees]="includeInfosCalculees"
  ></app-bon-list-globale-datagrid>
  <app-bon-list-lieu-stockage-datagrid
    #bonListLieuStockageDatagridComponent
    *ngIf="selectedLieuStockage != null"
    [lieuStockage]="selectedLieuStockage"
    [fluxEtapeDataSource]="fluxEtapeDataSource"
    [includeInfosCalculees]="includeInfosCalculees"
  ></app-bon-list-lieu-stockage-datagrid>
</div>

<dx-popup
title = "Importer un fichier pour générer des bons"
[(visible)]="showImportPopup"
(onHiding)="onCloseImportPopup()"
[showCloseButton]="true"
[resizeEnabled]="true"
[width]="450"
[height]="370"
>
  <div style="display: flex; align-items: baseline;">
    Type de fichier :
    <dx-select-box
      #typeImportBonSelectBox
      [items]="typeFichierImportBon"
      [width]="220"
      [showClearButton]="true"
      displayExpr="label"
      valueExpr="id"
      [value]="selectedTypeFichierImportBon"
      [searchEnabled]="true"
      (onValueChanged)="onTypeFichierImportValueChanged($event)"
    ></dx-select-box>
  </div>

  <dx-file-uploader #fileUploader
    [multiple]="false"
    [(value)]="files"
    name="files[]"
    [allowedFileExtensions]="['.xlsx']"
    uploadMode="useForm"
    selectButtonText="Choisir un fichier Excel"
    labelText="ou Glisser/Déposer le fichier"
    readyToUploadMessage=""
    class="uploader">
  </dx-file-uploader>

  <div style="display: flex; justify-content: center; margin-top: 12px;">
    <dx-button
      type="danger"
      text="Annuler"
      style="margin: 0 10px 0 20px;"
      (onClick)="onCloseImportPopup()"
    ></dx-button>
    <dx-drop-down-button
      text="Générer les bons"
      icon="upload"
      [items]="mouvementTypeDataSource"
      displayExpr="intitule"
      keyExpr="id"
      style="margin-right: 40px;"
      [width]="220"
      (onItemClick)="importBon($event)"
      [dropDownOptions]="dropDownOptionsCreerBon"
    ></dx-drop-down-button>
  </div>

  <div [hidden]="!showLoader" style="display: flex; justify-content: center; align-items: center; margin-top: 15px;">
    <dx-load-indicator [visible]="showLoader" height="50" width="50"></dx-load-indicator>
  </div>
</dx-popup>